import { ga } from 'js/analytics/adapters'
export const trackVideoFinished = () => {
  ga.track('Video finished')
}
